import { CSSProperties } from 'react';

export const container: CSSProperties = {
  bottom: 96,
  position: 'fixed',
  right: 84,
  zIndex: 9999,
};

export const image1: CSSProperties = {
  cursor: 'pointer',
  height: 60,
  width: 60,
};
